export default `
  fragment ReadingJournalSummaryFragment on reading_journals_summary {
    userId:user_id
    bookId:book_id
    journalsCount:journals_count
    lastUpdatedAtRaw:last_updated_at
  }
`;
